/** Figma panel width → height anchors — interpolate continuously (see rive skill). */

export const STACKED_HEIGHT_ANCHORS = [
  [335, 466],
  [1376, 701],
] as const;

export const HORIZONTAL_HEIGHT_ANCHORS = [
  [335, 466],
  [624, 445],
  [1376, 445],
] as const;

export type HeightAnchors = readonly (readonly [number, number])[];

export function computePanelHeight(
  width: number,
  anchors: HeightAnchors
): number {
  const first = anchors[0];
  if (!first) return 0;

  const [minWidth, minHeight] = first;

  if (width <= minWidth) {
    return Math.round(width * (minHeight / minWidth));
  }

  let prevWidth = first[0];
  let prevHeight = first[1];

  for (let i = 1; i < anchors.length; i++) {
    const anchor = anchors[i];
    if (!anchor) continue;
    const [nextWidth, nextHeight] = anchor;
    if (width <= nextWidth) {
      const progress = (width - prevWidth) / (nextWidth - prevWidth);
      return Math.round(prevHeight + progress * (nextHeight - prevHeight));
    }
    prevWidth = nextWidth;
    prevHeight = nextHeight;
  }

  return prevHeight;
}
